import { FormControl } from "@chakra-ui/react";
import { InspectionItemResult } from "interfaces/models/inspectionItemResult";
import { useFieldState } from "./useFieldState";

interface Props<T = any> {
  item: InspectionItemResult;
  isReadOnly?: boolean;
  isDraggable?: boolean;
  isDisabled?: boolean;
}

function withReviewer<ComponentProps>(
  Component: React.ComponentType<ComponentProps>
) {
  return (props: Props & ComponentProps) => {
    const { isInvalid, isDisabled, ...attributes } = useFieldState(
      props.item?.id,
      {
        isReadOnly: props.isReadOnly,
        dataType: props.item.dataType,
      }
    );

    return (
      <FormControl
        data-id={props.item?.id}
        isInvalid={isInvalid}
        scrollMarginTop="60px"
      >
        <Component
          {...(props as ComponentProps)}
          {...attributes}
          isDisabled={props.isDisabled || isDisabled}
        />
      </FormControl>
    );
  };
}

export default withReviewer;
